import * as VitaloJak2Api from '../../../misc/api/DeviceLinkApi/VitaloJak2';
import * as VitaloJak2Messages from '../../../misc/api/DeviceLinkApi/VitaloJak2Messages';
import { Device } from '../../../misc/api/DeviceLinkApi/Devices';
import { QueryCondition } from '../../../misc/api/apiTypes';
import { StudyScheduleSession, WebPortalClient, Subject } from 'webportalclient';
import { WebPortalLegacyClientInternal } from '../../../misc/api/WebPortalTokenClient';


export const VitaloJak2CheckExistingData = async (client: WebPortalClient, legacyClient: WebPortalLegacyClientInternal, subjectParam: Subject, device: Device, subjectId: string, selectedSessions: StudyScheduleSession[], hasForceReconfigurePermission: boolean, raiseConfigurationError: (message: string, isWarning: boolean) => void) => {
    const dataCheck = await VitaloJak2Api.ApiCheckData(device.id);

    const currentStudyId = subjectParam.site.studyId;

    const deviceId = device.id;

    const studyOnDevice = await VitaloJak2Api.ApiGetStudy(deviceId);
    const subjectOnDevice = await VitaloJak2Api.ApiGetSubject(deviceId);
    const siteOnDevice = await VitaloJak2Api.ApiGetSite(deviceId);
    
    const getStudy = await client.getStudy(currentStudyId);

    const sameStudy = studyOnDevice.studyId.includes(getStudy.protocol);

    if (!dataCheck.hasRecordings) {
        if (subjectOnDevice.subjectId.trim().length > 0) {
            raiseConfigurationError(VitaloJak2Messages.ReconfigureConfiguredWithNoRecordingsMessage(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), true);
        }
    } else {
        if (!sameStudy) {
            if (hasForceReconfigurePermission) {
                raiseConfigurationError(VitaloJak2Messages.ReconfigureAllowedWarning(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), true);
            } else {
                raiseConfigurationError(VitaloJak2Messages.ReconfigureBlockedFromOtherStudyMessage(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), false);
                return false;
            }
        } else {
            const recordingsOnDevice = await VitaloJak2Api.ApiGetRecordings(device.id);
            if (recordingsOnDevice.length > 0) {
                const uploadRecordingCompletedFilters = [{
                    Member: 'Id',
                    Values: recordingsOnDevice.map(x => x.externalCode),
                }, {
                    Member: 'UploadEndTime',
                    Values: [null],
                    Condition: QueryCondition.NotEqual,
                }];

                const completedCoughSessions = await legacyClient.getCoughSessions(uploadRecordingCompletedFilters);

                if (completedCoughSessions.Data.length === recordingsOnDevice.length) {
                    if (subjectOnDevice.subjectId.trim().length > 0) {
                        raiseConfigurationError(VitaloJak2Messages.ReconfigureConfiguredWithNoRecordingsMessage(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), true);
                    }
                } else {
                    if (hasForceReconfigurePermission) {
                        raiseConfigurationError(VitaloJak2Messages.ReconfigureAllowedWarning(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), true);
                    } else {
                        raiseConfigurationError(VitaloJak2Messages.ReconfigureBlockedMessage(subjectOnDevice.subjectId, siteOnDevice.siteId, studyOnDevice.studyId), false);
                        return false;
                    }
                }
            }
        }
    }
    return true;
}
